export default "Wie\nWarum\nWie viele\nwie man"